import styles from "./main.module.css";
import { Link, To } from "react-router-dom";

interface SideBarItemsProps {
  icon: React.ReactNode;
  name: string;
  link?: To;
  onClick?: () => void;
  isActive?: boolean
}

const SideBarItem: React.FC<SideBarItemsProps> = ({ icon, name , link='/', onClick, isActive}) => {
  return (
    <Link to={link} className={`${styles.sideBarItem} ${isActive ? styles.active : '' }`} onClick={onClick}>
      {icon}
      <span>{name}</span>
    </Link>
  );
};

export default SideBarItem;
